<template>
  <v-container id="data-tables" tag="section">
    <v-card flat class="my-0">
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{ $t("orderlines") }}
        </div>
      </template>
      <div
        v-if="
          order.state_id == 1 ||
            $auth.user().permissions.includes('order.editall')
        "
        class="text-right"
      >
        <v-btn class="ma-1 mb-3" color="primary" @click="selectType()">
          {{ $t("create") }}
        </v-btn>
        <v-dialog v-if="dialog" v-model="dialog" eager>
          <Typeselect
            :selectedTypeCallback="selectedTypeCallback"
            :selectedFavoriteCallback="selectedFavoriteCallback"
            :order="$route.params.id"
          ></Typeselect>
        </v-dialog>
        <v-dialog v-model="orderLineDialog" eager>
          <OrderLineForm
            v-if="(selectedDoorType || selectedFavorite) && orderLineDialog"
            :doorType="selectedDoorType"
            :favorite="selectedFavorite"
            :nextNumber="nextNumber"
            :editOrderLine="editOrderLine"
            :saveCallback="saveOrderlineCallback"
          ></OrderLineForm>
        </v-dialog>
      </div>
      <!--      <v-text-field-->
      <!--        v-model="search"-->
      <!--        append-icon="mdi-magnify"-->
      <!--        class="ml-auto"-->
      <!--        :label="$t('search')"-->
      <!--        hide-details-->
      <!--        single-line-->
      <!--        style="max-width: 250px;"-->
      <!--      />-->
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="total"
        :loading="loading"
        :multi-sort="false"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [10, 15, 50, -1]
        }"
      >
        <template v-slot:item.door_type.name="{ item }">
          <v-row>
            <v-col cols="1">
              <v-img
                v-if="
                  item.door_type.documents.find(
                    icon => icon.id === item.icon_id
                  )
                "
                :src="
                  item.door_type.documents.find(
                    icon => icon.id === item.icon_id
                  ).thumb | addToken
                "
                height="50"
                contain
                flat
              >
              </v-img>
              <v-img
                :src="item.door_type.icon | addToken"
                height="50"
                contain
                flat
                v-else-if="item.door_type.icon"
              ></v-img>
              <v-img
                src="/img/tmp/default.png"
                height="50"
                contain
                flat
                v-else
              ></v-img>
            </v-col>
            <v-col class="pl-1">
              {{ item.door_type.name }}
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.door_type.code="{ item }">
          <span v-if="$auth.user().permissions.includes('doorType.update')"
            ><a target="_blank" :href="'/doortype/' + item.door_type.id">{{
              item.door_type.code
            }}</a></span
          >
          <span v-else>{{ item.door_type.code }}</span>
        </template>
        <template v-slot:item.action="{ item }">
          <div
            v-if="
              order.state_id == 1 ||
                $auth.user().permissions.includes('order.editall')
            "
          >
            <v-icon small class="mr-2" @click="duplicateItem(item)">
              mdi-content-duplicate
            </v-icon>
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon
              v-if="item.label_entry == null"
              small
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon>
            <template
              v-if="
                $auth.user().permissions.includes('order.editall') &&
                  order.state_id >= 3
              "
            >
              <span class="mr-3">|</span>
              <v-icon
                v-if="item.label_entry != null"
                class="mr-3"
                small
                color="primary"
                @click="deleteLabel(item)"
              >
                mdi-label-off
              </v-icon>
              <v-icon
                v-if="
                  item.label_entry != null &&
                    item.label_entry.shipping_date == null &&
                    item.label_entry.stock_entry_date != null
                "
                class="mr-3"
                small
                @click="sendLabel(item)"
              >
                mdi-send
              </v-icon>
              <v-icon
                v-if="item.label_entry == null"
                small
                @click="reassignLabel(item)"
              >
                mdi-label-outline
              </v-icon>
            </template>
          </div>
          <div v-if="item.label_entry">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="$auth.user().permissions.includes('order.editall')"
                  v-bind="attrs"
                  v-on="on"
                  large
                  :color="labelStatusColor(item.label_entry)"
                  :title="labelStatusTitle(item.label_entry)"
                >
                  mdi-label
                </v-icon>
                <v-icon v-else v-bind="attrs" v-on="on" large>
                  mdi-label
                </v-icon>
              </template>
              <span v-if="item.label_entry"
                ><span v-if="item.label_entry.labelType"
                  >{{ item.label_entry.labelType.name }} |</span
                >
                {{ item.label_entry.real_number }}
                <span v-if="item.label_entry.shipping_date"
                  >|
                  {{
                    $t("send_at") + " " + item.label_entry.shipping_date
                  }}</span
                >
              </span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
      <v-divider class="mt-3" />
    </v-card>
  </v-container>
</template>

<script>
import {
  fetchOrderlines,
  fetchHandbooks,
  deleteOrderline,
  duplicateOrderline,
  deleteOrderlineLabel,
  reassignOrderlineLabel,
  sendOrderlineLabel
} from "../shared/services";
import Typeselect from "../item/typeselect";
import OrderLineForm from "../item/orderLineForm";
import { persistentTableOptions } from "../../../plugins/mixins";

export default {
  name: "app-order-list",
  mixins: [persistentTableOptions],
  components: {
    Typeselect,
    OrderLineForm
  },
  props: {
    beforeCreate: {
      type: Function
    },
    order: null,
    getHandbooks: null
  },
  data() {
    return {
      loading: true,
      options: {
        itemsPerPage: 50
      },
      total: 0,
      search: "",
      items: [],
      dialog: false,
      orderLineDialog: false,
      selectedDoorType: null,
      editOrderLine: null,
      selectedFavorite: null
    };
  },

  mounted() {
    this.getData();
  },

  computed: {
    nextNumber() {
      let lastNumber = 0;
      this.items.map(item => {
        if (parseInt(item.position) > lastNumber) {
          lastNumber = parseInt(item.position);
        }
      });
      return lastNumber + 1;
    },
    headers() {
      return [
        {
          text: this.$t("no."),
          align: "left",
          value: "position",
          sortable: false
        },
        {
          text: this.$t("no_internal"),
          align: "left",
          value: "number_customer",
          sortable: false
        },
        {
          text: this.$t("Code"),
          value: "door_type.code",
          sortable: false
        },
        {
          text: this.$t("Doortype"),
          value: "door_type.name",
          sortable: false
        },

        {
          text: this.$t("width"),
          value: "width",
          sortable: false
        },
        {
          text: this.$t("height"),
          value: "height",
          sortable: false
        },
        {
          text: this.$t("real_number"),
          value: "label_entry.real_number"
        },
        { text: "", value: "action", sortable: false }
      ];
    }
  },
  methods: {
    // Numbering-only entries (no plaque/labelType) skip warehouse checks
    isNumberingOnly(labelEntry) {
      return !!(labelEntry && !labelEntry.labelType);
    },
    labelStatusColor(labelEntry) {
      if (this.isNumberingOnly(labelEntry) || labelEntry.shipping_date) {
        return "green";
      }
      if (labelEntry.stock_entry_date) {
        return "";
      }
      return "orange";
    },
    labelStatusTitle(labelEntry) {
      if (this.isNumberingOnly(labelEntry)) {
        return "Nummerierung";
      }
      if (labelEntry.shipping_date) {
        return "ausgeliefert";
      }
      if (labelEntry.stock_entry_date) {
        return "im Lager";
      }
      return "nicht im Lager";
    },
    async getData() {
      this.loading = true;
      let response = await fetchOrderlines(
        { ...this.options, search: this.search },
        this.$route.params.id
      );
      this.items = response.data;
      this.total = response.meta.total;
      this.loading = false;
      this.$emit("update:orderLines", this.items);
    },
    async deleteItem(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this Orderline?")
        )
      ) {
        let resp = await deleteOrderline(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
        this.getHandbooks();
      }
    },
    async deleteLabel(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to delete this assigned label?")
        )
      ) {
        let resp = await deleteOrderlineLabel(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async reassignLabel(item) {
      if (
        await this.$root.$confirm(
          this.$t("Delete"),
          this.$t("Are you sure to reassign a new label?")
        )
      ) {
        let resp = await reassignOrderlineLabel(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async sendLabel(item) {
      if (
        await this.$root.$confirm(
          this.$t("save"),
          this.$t("Are you sure to set the label as send?")
        )
      ) {
        let resp = await sendOrderlineLabel(item.id);
        if (resp.success) {
          this.$notification(resp.message, { type: "success" });
        } else {
          this.$notification(resp.message, { type: "error" });
        }
        this.getData();
      }
    },
    async duplicateItem(item) {
      let url = item.id;
      let resp = await duplicateOrderline(item.id);
      if (resp.success) {
        this.$notification(resp.message, { type: "success" });
      } else {
        this.$notification(resp.message, { type: "error" });
      }
      this.getData();
      this.getHandbooks();
    },
    editItem(item) {
      this.editOrderLine = item;
      this.selectedDoorType = item.door_type;
      this.orderLineDialog = true;
    },
    saveOrderlineCallback() {
      this.getData();
      this.getHandbooks();
      this.orderLineDialog = false;
    },
    selectType() {
      this.beforeCreate(true).then(() => {
        this.dialog = true;
      });
    },
    selectedTypeCallback(type) {
      this.dialog = false;
      this.selectedDoorType = type;
      this.orderLineDialog = true;
    },
    selectedFavoriteCallback(favorite) {
      this.dialog = false;
      this.editOrderLine = null;
      this.selectedDoorType = favorite.door_type;
      this.selectedFavorite = favorite;
      this.orderLineDialog = true;
    }
  },
  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true
    },
    search: {
      handler() {
        this.getData();
      }
    },
    orderLineDialog: {
      handler(val) {
        if (!val) {
          this.editOrderLine = null;
          this.selectedFavorite = null;
        }
      }
    },
    items: function() {
      this.$emit("update:orderLines", this.items);
    },
    "$route.params.id": {
      handler() {
        this.getData();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
